<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2310"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2314"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2324"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2322" /></clipPath></defs><g
     id="g2316"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2318"><g
         id="g2320"
         clip-path="url(#clipPath2324)"><g
           id="g2326"
           transform="translate(236.9995,151)"><path
             d="M 0,0 H -222 V 346 H 124 V 202"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2328" /></g><g
           id="g2330"
           transform="translate(131.2905,497)"><path
             d="M 0,0 H 113.419 V -99.063 L 56.709,-70.349 0,-99.063 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2332" /></g><g
           id="g2334"
           transform="translate(290,318)"><path
             d="M 0,0 H -51 V -303 H 207 V 0 h -54"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path2336" /></g></g></g><path
       d="m 299,291 h 138 v 54 H 299 Z"
       style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
       id="path2338" /><g
       id="g2340"
       transform="translate(299,211.125)"><path
         d="M 0,0 15,-15 43.375,13.375"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
         id="path2342" /></g><g
       id="g2344"
       transform="translate(401.5,210.3125)"><path
         d="M 0,0 H 35.56"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
         id="path2346" /></g><g
       id="g2348"
       transform="translate(299,123.5)"><path
         d="M 0,0 15,-15 43.375,13.375"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
         id="path2350" /></g><g
       id="g2352"
       transform="translate(401.5,122.6885)"><path
         d="M 0,0 H 35.56"
         style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
         id="path2354" /></g></g></svg>
</template>
